import axios from "axios";
import { authHeader } from "../../../header";
import { toast } from "react-toastify";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const fetchAllBanks = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/bank-account/get-all-banks`, {
      headers: authHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching banks:", error);
    throw error; // ✅ re-throw so the caller handles it once
  }
};

export const verifyBankAccount = async (payload) => {
  try {
    const response = await axios.post(`${BASE_URL}/auth/admin/bank-account/verify`, payload, {
      headers: authHeader(),
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching banks:", error);
    toast.error(error?.message);
  }
};
